import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function PageNotFound(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 343 228",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M70.17 152.811H21v-19.44l46.55-72.69h22.22v74.49h16.87v17.64H89.77v23.52h-19.6v-23.52zm0-64.36h-.33l-28.91 46.72h29.24v-46.72zM285.85 152.811h-49.16v-19.44l46.55-72.69h22.22v74.49h16.82v17.64h-16.82v23.52h-19.61v-23.52zm3.42-64.36h-.33l-28.91 46.72h29.24v-46.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.03,
    d: "M168.12 66.451a51.948 51.948 0 00-47.998 32.051 51.954 51.954 0 0011.233 56.612 51.954 51.954 0 0056.599 11.298 51.95 51.95 0 0032.106-47.961 51.944 51.944 0 00-51.94-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M195.35 105.071c1.325 0 2.4-1.598 2.4-3.57 0-1.972-1.075-3.57-2.4-3.57-1.326 0-2.4 1.599-2.4 3.57 0 1.972 1.074 3.57 2.4 3.57zM107.1 103.011l122-27-24-7s-13-21.55-16.47-22c-3.47-.45-66.53 13-66.53 13l-4 30.36-11 12.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.91 129.221s31-12.39 44.56 10.69l-44.56-10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M192.47 140.431a.507.507 0 01-.44-.26c-13.19-22.43-43.63-10.59-43.93-10.47a.535.535 0 11-.39-1c.32-.12 31.57-12.29 45.21 10.91a.528.528 0 01-.18.71.536.536 0 01-.27.11zM132.5 176.111l-13.79-21.8 60.28-10.31 4.14 20.89 6.12-19.24 30.84 6.09-6.27 24.37H132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.742 128.839l5.557-.769 2.871 20.742a2.637 2.637 0 01-2.253 2.977l-.327.046a2.642 2.642 0 01-2.977-2.254l-2.871-20.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M215.23 152.371a3.146 3.146 0 01-3.11-2.71l-2.87-20.75a.503.503 0 01.43-.56l5.55-.77a.514.514 0 01.37.1.475.475 0 01.19.33l2.85 20.74a3.12 3.12 0 01-2.68 3.54l-.32.05a3.129 3.129 0 01-.41.03zm-4.92-23.1l2.8 20.25a2.147 2.147 0 002.41 1.83h.33a2.138 2.138 0 001.82-2.41l-2.8-20.25-4.56.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.439 109.29l-8.965 1.241 2.808 20.287 8.965-1.241-2.808-20.287z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M208.28 131.331a.539.539 0 01-.3-.1.454.454 0 01-.19-.33l-2.81-20.3a.489.489 0 01.09-.37.53.53 0 01.33-.19l9-1.24a.498.498 0 01.372.096.493.493 0 01.188.334l2.81 20.29a.503.503 0 01-.43.56l-9 1.24-.06.01zm-2.24-20.37l2.67 19.3 8-1.1-2.67-19.3-8 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M216.024 144.072l-2.625.363a3.2 3.2 0 00-2.731 3.608l4.006 28.944a3.2 3.2 0 003.609 2.731l2.625-.363a3.2 3.2 0 002.731-3.608l-4.006-28.944a3.2 3.2 0 00-3.609-2.731z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M217.83 180.261a3.696 3.696 0 01-3.66-3.19l-4-28.95a3.684 3.684 0 013.15-4.17l2.64-.36a3.688 3.688 0 014.16 3.15l4 29a3.703 3.703 0 01-3.15 4.16l-2.64.37-.5-.01zm-1.36-35.71a2.285 2.285 0 00-.37 0l-2.64.36a2.677 2.677 0 00-1.78 1.05 2.633 2.633 0 00-.52 2l4 29a2.713 2.713 0 003 2.3l2.64-.37a2.697 2.697 0 002.3-3l-4-29a2.703 2.703 0 00-2.66-2.33l.03-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.24 128.771c13.271 0 24.03-10.759 24.03-24.03 0-13.272-10.759-24.03-24.03-24.03s-24.03 10.758-24.03 24.03c0 13.271 10.759 24.03 24.03 24.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M209.22 129.271a24.537 24.537 0 01-18.487-40.665 24.535 24.535 0 0125.511-7.392 24.542 24.542 0 0117.296 20.157 24.57 24.57 0 01-20.9 27.67c-1.134.153-2.276.23-3.42.23zm0-48.07a23.536 23.536 0 00-22.804 17.593 23.546 23.546 0 008.569 24.714 23.541 23.541 0 0037.525-21.997 23.579 23.579 0 00-23.25-20.31h-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.24 124.261c10.781 0 19.52-8.739 19.52-19.52 0-10.78-8.739-19.52-19.52-19.52-10.781 0-19.52 8.74-19.52 19.52 0 10.781 8.739 19.52 19.52 19.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M209.23 124.761a19.997 19.997 0 01-19.988-19.31 19.998 19.998 0 0132.859-15.997 20 20 0 01-12.871 35.307zm0-39a19.002 19.002 0 00-18.94 20.95 18.999 18.999 0 0037.889-2.574 18.996 18.996 0 00-18.949-18.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.19 158.911a14.564 14.564 0 00-4.9-4c-5.73-3-12.3-2.9-18.33-1-2.14.68-6.29 1.65-6.51 4.49a2.644 2.644 0 001.91 2.5 7.857 7.857 0 003.35.13 8.649 8.649 0 00-4.53 1.14c-1.29.91-2 2.9-.94 4.11a3.388 3.388 0 001.75 1 8.007 8.007 0 004.45-.06c-1.567.3-3.093.78-4.55 1.43-.88.39-1.86 1.08-1.76 2 .1.92 1 1.34 1.82 1.62 1.725.592 3.528.929 5.35 1a10.536 10.536 0 00-4.35 1.87c-2 1.68-2 4.87.71 5.78a8.011 8.011 0 002.68.31c8 0 17.58-1 23-7.66a12.425 12.425 0 002.56-11.31 10.82 10.82 0 00-1.71-3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M208.28 181.701a8.426 8.426 0 01-2.78-.33 3.451 3.451 0 01-2.38-2.63 4.358 4.358 0 011.5-4 7.455 7.455 0 012.16-1.25 18.575 18.575 0 01-3-.77c-1.33-.46-2-1.14-2.15-2-.15-.86.62-1.9 2-2.55l.71-.3a5.302 5.302 0 01-.54-.13 3.773 3.773 0 01-2-1.14 2.767 2.767 0 01-.59-2.16 3.99 3.99 0 011.62-2.67c.311-.218.647-.4 1-.54a3.07 3.07 0 01-1.91-2.87c.23-2.92 3.84-4 6.22-4.73l.64-.19c6.68-2.11 13.33-1.74 18.71 1a14.992 14.992 0 015.07 4.18 11.46 11.46 0 011.81 3.48 12.883 12.883 0 01-2.65 11.78c-5.67 6.93-15.49 7.83-23.41 7.84l-.03-.02zm-.95-13.79c-1.111.282-2.195.66-3.24 1.13-.47.21-1.54.78-1.46 1.52.08.74.84 1 1.48 1.21 1.678.587 3.434.924 5.21 1a.494.494 0 01.396.779.505.505 0 01-.286.201c-1.5.278-2.92.882-4.16 1.77a3.311 3.311 0 00-1.17 3.06 2.433 2.433 0 001.72 1.87c.814.24 1.663.335 2.51.28 7.71 0 17.24-.86 22.64-7.47a11.907 11.907 0 002.48-10.85 10.494 10.494 0 00-1.66-3.17 13.875 13.875 0 00-4.73-3.9c-5.15-2.65-11.52-3-17.95-1l-.65.2c-2.12.64-5.34 1.61-5.52 3.85a2.176 2.176 0 001.58 2 4.848 4.848 0 001.79.22c.47-.05.93-.08 1.37-.11a.521.521 0 01.53.46.509.509 0 01-.45.54c-.45 0-.92.1-1.4.11a6.157 6.157 0 00-2.89.94 3.007 3.007 0 00-1.21 2 1.795 1.795 0 00.36 1.39c.407.417.929.703 1.5.82a7.667 7.667 0 003 .2c.4-.1.81-.19 1.21-.27a.5.5 0 01.58.37.508.508 0 01-.34.6c-.406.117-.82.201-1.24.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M176.43 105.121s12.18 18.3 4.81 18.56c-7.37.26-8-1.67-8-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M179.92 124.261c-6.18 0-7.07-1.69-7.19-2a.531.531 0 01.33-.66.521.521 0 01.65.33s.9 1.55 7.51 1.31a1.694 1.694 0 001.62-.84c1.58-3.07-4.4-13.25-6.84-16.91a.524.524 0 01.532-.773c.13.021.247.09.328.193.93 1.4 9 13.8 6.9 18a2.684 2.684 0 01-2.5 1.41l-1.34-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M210.35 111.661c2.441 0 4.42-3.371 4.42-7.53 0-4.159-1.979-7.53-4.42-7.53s-4.42 3.371-4.42 7.53c0 4.159 1.979 7.53 4.42 7.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M156.26 110.221c1.861 0 3.37-2.727 3.37-6.09s-1.509-6.09-3.37-6.09c-1.861 0-3.37 2.727-3.37 6.09s1.509 6.09 3.37 6.09z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(PageNotFound);
export default ForwardRef;